import { Suspense, useEffect } from "react";
import "./App.scss";
import "translation";
import { BrowserRouter } from "react-router-dom";
import Routes from "Routes";
import { Amplify } from "aws-amplify";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { poolData } from "shared/components/user-pool/AwsConfig";
import { useDispatch } from "react-redux";
import { getLoggedUser } from "explorer/reducers/users";
import { autenticado } from "shared/helpers/auth-functions";
import { getGeneros, getGenerosSpotify } from "explorer/reducers/generos";
import { loadUserId } from "shared/helpers/browser-id";
import { Tour } from "radar/components";
import { getCountries } from "explorer/reducers/countries";
import { Personify } from "shared/components";
import { getMonitoredData } from "explorer/reducers/monitored-data";
import { getUserDistroToken } from "explorer/reducers/artistas";

Amplify.configure(poolData);
loadUserId();
const {
  REACT_APP_SENTRY_DSN,
  REACT_APP_SENTRY_SAMPLE_RATE,
  REACT_APP_SENTRY_ENVIORNMENT,
} = process.env;
Sentry.init({
  dsn: REACT_APP_SENTRY_DSN,
  integrations: [
    new Integrations.BrowserTracing(),
    new Sentry.Integrations.Breadcrumbs({
      console: false,
    }),
  ],
  environment: REACT_APP_SENTRY_ENVIORNMENT,
  tracesSampleRate: Number(REACT_APP_SENTRY_SAMPLE_RATE || 1.0),
});

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    if (autenticado()) {
      dispatch(getLoggedUser());
      dispatch(getGenerosSpotify());
      dispatch(getGeneros());
      dispatch(getCountries());
      dispatch(getMonitoredData());
      dispatch(getUserDistroToken());
    }
  }, [dispatch]);

  return (
    <Suspense fallback="loading">
      <BrowserRouter>
        <Tour>
          <Personify />

          <Routes />
        </Tour>
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
